/*
 *
 * SiteOwnerTestResults actions
 *
 */

import { createAction } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';

export const fetchTests = createAction<boolean>(`${SLICE_NAME}/fetchTests`);
